import { render, staticRenderFns } from "./ProjectUsers.vue?vue&type=template&id=dfe65c96&scoped=true&"
import script from "./ProjectUsers.vue?vue&type=script&lang=js&"
export * from "./ProjectUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe65c96",
  null
  
)

export default component.exports